import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { fadeIn, fadeOut } from 'src/app/animations';
import { GlobalSettingsService } from "src/app/services/ui/global-settings.service";
import { GenericModalComponent } from "../generic-modal/generic-modal.component";
import { AuthService } from "src/app/services/auth.service";

@Component({
	selector: 'unregister',
	templateUrl: './unregister.component.html',
	styleUrls: ['./unregister.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss', '../stylesheets/forms-container.scss'],
	animations: [fadeIn(200), fadeOut(200)]
})
export class UnregisterComponent implements OnInit, OnDestroy {

	constructor(
		private authService: AuthService,
	) { }

	ngOnInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	onDeleteAccountConfirmed() {

	}

	onDelete() {
		localStorage.setItem('rurl', `${location.origin}/accounts?isAutoredirect=1&page=5`);
		localStorage.setItem('platform_type_id', `2`);
		this.authService.login();
	}

	ngOnDestroy(): void {

	}
}